import { Navigate, Outlet, useLocation } from "react-router-dom";
import useRestoreAuthSessionOnce from "../features/auth/session/useRestoreAuthSessionOnce";
import Loader from "./Loader";

const PersistLogin = () => {
  const { status } = useRestoreAuthSessionOnce();
  const location = useLocation();

  if (status === "unknown" || status === "restoring") return <Loader />;
  if (status === "unauthenticated") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default PersistLogin;
